export default __webpack_public_path__ + "723b8f04417e06a01867f2e7c9338204.png";